import { useGridApiRef } from '@mui/x-data-grid-pro';
import { Card, CardContent } from '@mui/material';
import SupplierTabsCard from './SupplierTabsCard';

export default function SupplierView({
  setSuppliersData,
  setNonStrategicSuppliersData,
  readOnly,
  showSensitiveInfo,
  strategyInformation,
  setSuppliersDirty,
  setSuppliersMessage,
  isEdit,
  isCreate = false,
  userInfoMap,
  setNonStrategicSuppliersList,
  donotEnforceCommentsWhenSupplierTypeChanged,
  commonProps,
  supplierScopeOverview
}) {
  const strategicSupplierDataGridApiRef = useGridApiRef();
  const nonStrategicSupplierDataGridApiRef = useGridApiRef();

  return (
    <Card>
      <CardContent>
        <SupplierTabsCard
          strategicSupplierDataGridApiRef={strategicSupplierDataGridApiRef}
          nonStrategicSupplierDataGridApiRef={
            nonStrategicSupplierDataGridApiRef
          }
          readOnly={readOnly}
          showSensitiveInfo={showSensitiveInfo}
          strategyInformation={strategyInformation}
          setSuppliersDirty={setSuppliersDirty}
          setSuppliersMessage={setSuppliersMessage}
          isEdit={isEdit}
          isCreate={isCreate}
          userInfoMap={userInfoMap}
          commonProps={commonProps}
          supplierScopeOverview={
            supplierScopeOverview || strategyInformation?.scope
          }
          setNonStrategicSuppliersList={setNonStrategicSuppliersList}
          donotEnforceCommentsWhenSupplierTypeChanged={
            donotEnforceCommentsWhenSupplierTypeChanged
          }
          setSuppliersData={setSuppliersData}
          setNonStrategicSuppliersData={setNonStrategicSuppliersData}
          showProspectiveSuppliers={false}
        />
      </CardContent>
    </Card>
  );
}
